/* eslint-disable no-undef */
/* eslint-disable func-names */
/* eslint linebreak-style: ["error", "windows"] */
/**
 * Sticky Header
 * @param   {object/string} opts
 * @return  {object/string}
 */
export default function () {

    const ajaxLoadMore = () => {
        console.log('hello');
    }




}
